import React from 'react'
import { string } from 'prop-types'
import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import ModelryLogo from 'images/moderly_RGB_white.svg'
import CgdreamLogo from 'images/cgdream_RGB_white.svg'

function FooterPresentationBrands({className = ''}) {
  return (
    <div className={classnames('footer-presentation__brands', className)}>
      <div className="footer-presentation__brand">
        <p className="footer-presentation__brand-label">ENTERPRISE 3D AT SCALE</p>
        <a href="https://modelry.ai" target="_blank" rel="noopener noreferrer">
          <img
            className="footer-presentation__brand-logo"
            src={ModelryLogo}
            alt="Modelry"
            width="140"
            height="36"
            loading="lazy"
          />
        </a>
      </div>

      <div className="footer-presentation__brand">
        <p className="footer-presentation__brand-label">AI IMAGE GENERATION</p>
        <a href="https://cgdream.ai" target="_blank" rel="noopener noreferrer">
          <img
            className="footer-presentation__brand-logo"
            src={CgdreamLogo}
            alt="CGDream"
            width="140"
            height="36"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  )
}

FooterPresentationBrands.propTypes = {
  className: string,
}

export default FooterPresentationBrands
